<div class="password-reset-wrapper">
  <lcs-loading-overlay [show]="isLoading">
    <form class="password-reset" [formGroup]="form" (submit)="onSubmit()">
      <ndt-logo></ndt-logo>
      <h4 class="account-verification-header">Welcome to NDT</h4>
      @if (canAccountBeFinalized) {
        <p>Please create a password for your new account</p>
        <div class="login-form-controls">
          <ndt-password-form-control></ndt-password-form-control>
          @if (submitState?.error?.userMessage) {
            <div class="account-verification-password-error-message">
              {{ submitState?.error?.userMessage }}
            </div>
          }
        </div>
        <lcs-progress-button [useCallState]="submitState$" type="submit">Continue</lcs-progress-button>
      } @else {
        @if (canAccountBeFinalized === false) {
          <p>
            Account has already been set up. Please continue to the login page.
          </p>
        }
        @if (canAccountBeFinalized === null) {
          <p>{{
            callState?.error ? callState.error.userMessage : 'Please wait.'
          }}</p>
        }
        <input
          [disabled]="callState.error"
          class="continue-button"
          type="button"
          value="Continue"
          (click)="continue()"
          />
        }
      </form>
    </lcs-loading-overlay>
  </div>
